import { Command } from './Command';
import { VideoEditor } from '../VideoEditor';
import { Element } from '../models/Element';
import { EditorChangeType } from '../types';

export class AddElementCommand implements Command {
  private editor: VideoEditor;
  private trackId: string;
  private element: Element;
  private elementAdded: boolean = false;

  // TODO: Time? Collision check? Ripple?
  constructor(editor: VideoEditor, trackId: string, element: Element) {
    this.editor = editor;
    this.trackId = trackId;
    this.element = element;
  }

  execute(): boolean {
    const success = this.editor.timeline.addElement(this.trackId, this.element);
    if (success) {
      this.elementAdded = true;
      this.editor.markDirty('add_element_command');
      this.editor.notifyObservers(EditorChangeType.ELEMENT_ADDED, {
        element: this.element,
        trackId: this.trackId,
      });
    }
    return success;
  }

  undo(): boolean {
    if (!this.elementAdded) return false;

    const success = this.editor.timeline.removeElement(this.element.id);
    if (success) {
      this.elementAdded = false;
      this.editor.markDirty('add_element_command_undo');
      this.editor.notifyObservers(EditorChangeType.ELEMENT_REMOVED, {
        elementId: this.element.id,
        element: this.element,
      });
    }
    return success;
  }

  redo(): boolean {
    if (this.elementAdded) return false;
    return this.execute();
  }

  getDescription(): string {
    return `Add ${this.element.type} element to track ${this.trackId}`;
  }
}
